// @ts-nocheck
// Greif UI Kit = line-upload
import * as React from "react";

const Upload: React.FC = () => {
    /* Store Custom Code - Start */
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M3 18.3v-3.6a.9.9 0 0 1 1.8 0v3.6a.9.9 0 0 0 .9.9h12.6a.9.9 0 0 0 .9-.9v-3.6a.9.9 0 0 1 1.8 0v3.6a2.7 2.7 0 0 1-2.7 2.7H5.7A2.7 2.7 0 0 1 3 18.3m8.1-3.6V6.072L8.136 9.036a.9.9 0 1 1-1.272-1.272l4.5-4.5.068-.062a.9.9 0 0 1 1.204.061l4.5 4.5a.9.9 0 1 1-1.272 1.273L12.9 6.072V14.7a.9.9 0 1 1-1.8 0"
            />
        </svg>
    );
    /* Store Custom Code - End */
};

export default React.memo(Upload);
